export const isRetryableError = (error: any) => {
	const status = error?.status;
	const isServerError = typeof status === 'number' && status >= 500 && status < 600;
	const isNetworkError = status === 'FETCH_ERROR' || status === 'TIMEOUT_ERROR';

	return isServerError || isNetworkError;
};

export const getErrorMessage = (err: unknown, fallback: string): string => {
	const error = err as { data?: { message?: string | string[] }; message?: string };
	const message = error?.data?.message || error?.message;

	if (Array.isArray(message)) {
		return message.filter(Boolean).join(' ');
	}

	return (message as string) || fallback;
};

export interface ApiError {
	message?: string;
	name?: string;
	status?: number;
	error?: string;
	data?: { message?: string | string[] };
	response?: { status?: number; data?: { message?: string | string[] } };
}

export const asApiError = (err: unknown): ApiError => (err ?? {}) as ApiError;
